import React from "react";
import "./styles.css";

const Footer = ({ classicHeader, darkTheme, handleNavClick }) => {
  return (
    <footer
      id="footer"
      className={"section " + (darkTheme ? "footer-dark bg-dark-1" : "")}
    >
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        <div className="row">
          <div className="col-lg-6 text-center text-lg-start">
            <p className="mb-3 mb-lg-0">
              Copyright © 2026{" "}
              <a
                href="#home"
                className="fw-500"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick("home");
                }}
              >
                fachu.dev
              </a>
              {" | All Rights Reserved."}
            </p>
          </div>
          <div className="col-lg-6">
            {/* Enlaces de Terms & Policy y Disclaimer removidos temporalmente */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
